import React from 'react';
import { Table as AntTable } from 'antd';

// The APIs cap a page at this many rows (StandardPagination.max_page_size).
export const MAX_PAGE_SIZE = 1000;

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
const LARGE_PAGE_SIZES = [500, 1000];

/**
 * A table's own page-size options plus 500 and 1000, numerically sorted.
 * Row selection is per page, so large pages are how a bulk action (send,
 * export, delete) reaches more than a handful of rows.
 */
export const withLargePageSizes = (options = DEFAULT_PAGE_SIZE_OPTIONS) =>
  [...new Set([...options, ...LARGE_PAGE_SIZES].map(Number))]
    .filter((size) => size > 0 && size <= MAX_PAGE_SIZE)
    .sort((a, b) => a - b)
    .map(String);

/**
 * Drop-in for antd's Table - import it instead of `Table` from 'antd'.
 * Every paginated table offers 500 / 1000 rows per page; everything else is
 * passed through untouched, and `pagination={false}` stays off.
 */
const Table = React.forwardRef(({ pagination, ...props }, ref) => (
  <AntTable
    ref={ref}
    {...props}
    pagination={
      pagination === false
        ? false
        : { ...pagination, pageSizeOptions: withLargePageSizes(pagination?.pageSizeOptions) }
    }
  />
));

// Keep antd's statics (Table.Summary, Table.Column, Table.SELECTION_ALL, ...).
Object.keys(AntTable).forEach((key) => {
  if (!(key in Table)) Table[key] = AntTable[key];
});

export default Table;
